import { render } from "./ModalSignUp.vue?vue&type=template&id=e12dc15c&scoped=true"
import script from "./ModalSignUp.vue?vue&type=script&lang=js"
export * from "./ModalSignUp.vue?vue&type=script&lang=js"

import "./ModalSignUp.vue?vue&type=style&index=0&id=e12dc15c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\mkapp\\OneDrive\\Desktop\\Stage_Project\\Application_Front-end\\Moroccan-fork-front-end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e12dc15c"]])

export default __exports__